import React from 'react';
import { ICellRendererParams } from '@ag-grid-community/core';
import { Text } from '@amzn/storm-ui-v3';
import { useFormattedReportPeriod } from '@urc-ui/hooks/i18n';
import { StyledCellWrapper } from '@urc-ui/components/styles';
import { PRESET_PERIOD_TRANSLATION_MAP } from '@urc-ui/utils/date-utils';

export const ReportPeriodCell = (props: ICellRendererParams) => {
  const { reportPeriod, reportStartDate, reportEndDate } = props.data;
  const formattedReportPeriod = useFormattedReportPeriod(PRESET_PERIOD_TRANSLATION_MAP, reportPeriod, reportStartDate, reportEndDate);

  return (
    <StyledCellWrapper>
      <Text fontSize='small'>{formattedReportPeriod}</Text>
    </StyledCellWrapper>
  );
};
